import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SideNavComponent } from './sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideNavService } from './sidenav.service';
import { RouterModule } from '@angular/router';







@NgModule({
  declarations: [SideNavComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    BrowserAnimationsModule
  ],
  exports: [SideNavComponent],
  providers: [SideNavService]
})
export class SideNavModule {
}
